import type { PhotoReference } from '../types'

export const referenceHref = (projectId: string, r: PhotoReference): string =>
  r.kind === 'SNAG' ? `/project-setup/${projectId}/snags?openSnagId=${r.id}` : `/project/${projectId}/meetings/${r.meetingId}`
